export { default as WaitlistForm } from './WaitlistForm'



// WEBPACK FOOTER //
// ./src/components/waitlistForm/index.js